export const createContentCache = () => {
  let cachedContent = null;
  let inflightPromise = null;

  return {
    getCached: () => cachedContent,
    load: async (loader) => {
      if (cachedContent) {
        return cachedContent;
      }

      if (inflightPromise) {
        return inflightPromise;
      }

      inflightPromise = loader()
        .then((content) => {
          cachedContent = content;
          return content;
        })
        .finally(() => {
          inflightPromise = null;
        });

      return inflightPromise;
    },
    clear: () => {
      cachedContent = null;
      inflightPromise = null;
    },
  };
};
